import typeahead from "corejs-typeahead"; // eslint-disable-line

export default class Typeahead {
  constructor(el) {
    this.el = el;
    this.init();
  }

  init() {
    $('#the-basics .typeahead').typeahead(
      {
        hint: true,
        highlight: true,
        minLength: 1
      },
      {
        source: this._substringMatcher2()
      }
    );
  }

  /* eslint-disable class-methods-use-this */
  _substringMatcher2() {
    return function findMatches(q, cb) {
      // an array that will be populated with substring matches
      const matches = [];
      // const strs = [];
      $.ajax({
        url: '/autocomplete_ajax.php',
        type: 'POST',
        dataType: 'JSON',
        async: false,
        data: {
          mode: 'test',
          qry: q
        },
        success: data => {
          // console.log(data);
          data.forEach(str => {
            matches.push(str);
          });
        }
      });
      // console.log(matches);
      cb(matches);
    };
  }

  /* eslint-disable class-methods-use-this */
  _substringMatcher(strs) {
    return function findMatches(q, cb) {
      // an array that will be populated with substring matches
      const matches = [];

      // regex used to determine if a string contains the substring `q`
      const substrRegex = new RegExp(q, 'i');

      // iterate through the pool of strings and for any string that
      // contains the substring `q`, add it to the `matches` array
      $.each(strs, (i, str) => {
        if (substrRegex.test(str)) {
          matches.push(str);
        }
      });

      cb(matches);
    };
  }

  _getStates() {
    return [
      'Alabama',
      'Alaska',
      'Arizona',
      'Arkansas',
      'California',
      'Colorado',
      'Connecticut',
      'Delaware',
      'Florida',
      'Georgia',
      'Hawaii',
      'Idaho',
      'Illinois',
      'Indiana',
      'Iowa',
      'Kansas',
      'Kentucky',
      'Louisiana',
      'Maine',
      'Maryland',
      'Massachusetts',
      'Michigan',
      'Minnesota',
      'Mississippi',
      'Missouri',
      'Montana',
      'Nebraska',
      'Nevada',
      'New Hampshire',
      'New Jersey',
      'New Mexico',
      'New York',
      'North Carolina',
      'North Dakota',
      'Ohio',
      'Oklahoma',
      'Oregon',
      'Pennsylvania',
      'Rhode Island',
      'South Carolina',
      'South Dakota',
      'Tennessee',
      'Texas',
      'Utah',
      'Vermont',
      'Virginia',
      'Washington',
      'West Virginia',
      'Wisconsin',
      'Wyoming'
    ];
  }
  /* eslint-enable class-methods-use-this */
}



// WEBPACK FOOTER //
// ./src/main/javascripts/modules/autocomplete.js